exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sortable-list .item {\n  border: 1px solid #ededed;\n  border-radius: 2px;\n  padding: 10px 16px;\n  margin: 5px 0 0 0;\n  background-color: white;\n}\n.sortable-list .item .handle {\n  display: flex;\n  justify-content: space-between;\n}\n.sortable-list .item .title {\n  cursor: move;\n}\n.sortable-list .item .expand {\n  font-size: 18px;\n}\n.sortable-list .item .settings {\n  display: none;\n}\n.sortable-list .item .settings.active {\n  display: block;\n}", ""]);

// exports
